export default __webpack_public_path__ + "static/media/dk.90f7d120.svg";